import { useMemo } from 'react';
import { formatNumber } from '@app/helpers/format';

export function useAprWithTooltip({
  totalApr,
  swapFeesApr,
  marketMakerAPR,
  farmBaseApr,
  nitroPoolApr
}: {
  totalApr?: number | undefined;
  swapFeesApr: number;
  marketMakerAPR: number;
  farmBaseApr?: number | undefined;
  nitroPoolApr?: number | undefined;
}) {
  const aprValues = useMemo(() => {
    const tooltip = [];
    let _apr = 0;

    if (totalApr) {
      _apr = totalApr + marketMakerAPR;
    } else {
      _apr = swapFeesApr + marketMakerAPR;
    }

    if (swapFeesApr) {
      tooltip.push({
        label: `Swap fees APR`,
        value: `${formatNumber(swapFeesApr, 2)}%`,
        color: 'white'
      });
    }

    if (farmBaseApr) {
      tooltip.push({
        label: `Farm base APR`,
        value: `${formatNumber(farmBaseApr, 2)}%`,
        color: 'white'
      });
    }

    if (marketMakerAPR) {
      tooltip.push({
        label: `Market Maker APR`,
        value: `${formatNumber(marketMakerAPR, 2)}%`,
        color: 'yellow'
      });
    }

    if (nitroPoolApr) {
      tooltip.push({
        label: `Nitro rewards`,
        value: `${formatNumber(nitroPoolApr, 2)}%`,
        color: 'nitro'
      });
    }

    return {
      apr: _apr,
      tooltip
    };
  }, [farmBaseApr, swapFeesApr, marketMakerAPR, totalApr, nitroPoolApr]);

  return aprValues;
}
